
/// 模块类型
export const moduleTypes = [
    { label: "影视模块", value: 1 },
    { label: "抖阴模块", value: 2 },
    { label: "社区模块", value: 3 }
]

// 模块展示类型
export const moduleShowTypes = [
    { label: "默认样式", value: 0 },
    { label: "列表样式", value: 1 },
    { label: "瀑布流列表样式", value: 2 },
    { label: "多专题切换样式", value: 3 },
    { label: "多专题文字样式", value: 4 },
    { label: "多专题图文样式", value: 5 },
    { label: "社区样式", value: 6 },
];

/// 主题类型
export const topicTypes = [
    { label: "默认", value: 0 },
    { label: "视频帖子", value: 1 },
    { label: "种子帖子", value: 2 },
    { label: "黄游帖子", value: 3 },
]
/// 帖子类型
const newsTypeMapper = {
    SP: '短视频帖子',
    MOVIE: '长视频帖子',
    COVER: '图片帖子',
    SEED_LINK: '种子贴子',
    AD_SP: '视频广告',
    YELLOW_GAME: '黄游帖子',
    AD: '图片广告'
}

// 是否展示自动上架
export const includeAutoReviews = [
    {
        label: "是",
        value: true,
    },
    {
        label: "否",
        value: false,
    },
]

export function getNewsTypeName(key) {
    return newsTypeMapper[key || 'AD'] || newsTypeMapper.AD
}

/// 视频权限
export const videoPermissionTypes = [
    { label: 'VIP会员', value: 0 },
    { label: '金币购买', value: 1 },
    { label: '免费', value: 2 },
]

/// 跑马灯类型
export const marqueeTypes = [
    {
        label: "十六岁模块",
        value: 0,
    },
    {
        label: "空间模块",
        value: 1,
    },
    {
        label: "暗黑模块",
        value: 2,
    },
]
// CurrentValue         PrizeType = 1  // 活跃值
//   Gold                 PrizeType = 2  // 金币
//   GoldExtra            PrizeType = 3  // 金币加赠券
//   Integral            PrizeType = 4  // 积分
//   VIPCard              PrizeType = 5  // 会员卡
//   VIPDiscount          PrizeType = 6  // 会员折扣卷
//   InKind               PrizeType = 7  // 实物
//   AiUndressCount       PrizeType = 8  // ai脱衣免费次数
//   AiChangeFaceDiscount PrizeType = 9  // ai视频换脸抵扣券
//   GoldVideoCoupon      PrizeType = 10 // 金币视频观影券
// 奖品类型 - 用于奖品列表新增、编辑
export const prizeTypes = [
    { label: '活跃值', value: 1, key: 'CurrentValue' },
    { label: '金币', value: 2, key: 'Gold' },
    { label: '金币加赠券', value: 3, key: 'GoldExtra' },
    { label: '积分', value: 4, key: 'Integral' },
    { label: '会员卡', value: 5, key: 'VIPCard' },
    { label: '会员折扣卷', value: 6, key: 'VIPDiscount' },
    { label: '实物', value: 7, key: 'InKind' },
    { label: 'ai脱衣次数', value: 8, key: 'AiUndressCount' },
    { label: 'ai视频换脸抵扣券', value: 9, key: 'AiChangeFaceDiscount' },
    { label: '金币视频观影券', value: 10, key: 'GoldVideoCoupon' },
]

/**
 * 每日活动-任务类型
 */
export const activityTaskTypes = [
    { label: "每日下载App", value: 0, },
    { label: "每日邀请用户", value: 1, },
    { label: "每日登陆", value: 2, },
    { label: "每日评论", value: 3, },
    { label: "每日发布", value: 4, },
    { label: "每日签到", value: 5, },
    { label: "每日观看视频", value: 6, },
    { label: "每日解锁金币视频", value: 7, },
    { label: "每日购买金币", value: 8, },
]

export const passTypes = [
    { label: '上架', value: 1 },
    { label: '下架', value: 2 }
]


/**
 * 排序类型0-正序 1-倒序
 */
export const sortTypes = [
    { label: "正序", value: 0 },
    { label: "倒序", value: 1 },
]

/**
 * 列表最大总数
 */
export const maxTotalTypes = [1000, 2000, 5000, 10000].map(v => ({ label: v.toString(), value: v }))

/**
 * 开关状态
 */
export const statuses = [
    {
        label: "开启",
        value: true,
    },
    {
        label: "关闭",
        value: false,
    }
]
/**
 * 积分兑换礼品类型
 */
export const integralPrizeTypes = [
    {
        label: "VIP兑换",
        value: 1,
    },
    {
        label: "AI黑科技",
        value: 2,
    },
    {
        label: "金币加赠券",
        value: 3,
    },
    {
        label: "金币观影券",
        value: 4,
    },
    {
        label: "实物奖励",
        value: 5,
    },
    {
        label: "幸运抽奖次数",
        value: 6,
    },
    {
        label: "兑换金币",
        value: 7,
    },
    {
        label: "AI抵扣券",
        value: 8,
    },
]

/**
 * 用户背包列表，物品类型
 * 
 */
export const goodsTypes = [
    { label: '楼风解锁折扣卷', value: 1 },
    { label: '会员折扣卷', value: 2 },
    { label: 'AI换脸折扣券', value: 3 },
    { label: '视频观影券', value: 4 },
    { label: '实物奖励', value: 5 },
    { label: 'AI黑科技券(AI免费次数)', value: 6 },
    { label: 'VIP兑换', value: 7 },
    { label: '金币加赠券', value: 8 },
]

export const innerLinkList = [
    { label: "会员中心", value: "yinseinner://vip_page" },
    { label: "金币钱包", value: "yinseinner://wallet_page" },
    { label: "推广", value: "yinseinner://universal_agent" },
    { label: "客服", value: "yinseinner://kefu" },
    { label: "社区", value: "yinseinner://community_page" },
    { label: "绑定手机号", value: "yinseinner://binding_page" },
    { label: "签到福利", value: "yinseinner://taskHall" },
    { label: "普通视频详情", value: "yinseinner://video_page?id=" },
    { label: "帖子详情页", value: "yinseinner://postdetail?id=" },
]
// 公告类型
export const noticeTypes = [
    { label: '官方公告', value: 'official_announcement' },
    { label: '活动公告', value: 'activity_announcement' },
]

export function getTypeLabel(val, types) {
    const type = types.find(v => v.value == val)
    if (type) {
        return type.label
    }
    return ''
}

export function getMarqueeTypeName(val) {
    return getTypeLabel(val, marqueeTypes)
}

const tagStyles = 'success/warning/danger/info'.split('/')
const tagStylesCount = tagStyles.length
export function getTagStyle(val) {
    return tagStyles[val % tagStylesCount]
}